import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function OUniverzitetu() {
  const [t] = useTranslation();

  const breadcrumbTitle = t("breadcrumb.home", { defaultValue: "Početna" });
  const breadcrumbSubtitle = t("pages.o-univerzitetu", {
    defaultValue: "O univerzitetu",
  });

  const heroImg = `${process.env.PUBLIC_URL}/assets/img/erasmuskonkursi/adriatiklogo.png`;

  const facts = [
    {
      icon: "fas fa-calendar-check",
      label: t("universityPage.facts.foundedLabel"),
      value: t("universityPage.facts.foundedValue"),
    },
    {
      icon: "fas fa-layer-group",
      label: t("universityPage.facts.pillarsLabel"),
      value: t("universityPage.facts.pillarsValue"),
    },
    {
      icon: "fas fa-users",
      label: t("universityPage.facts.studentsLabel"),
      value: t("universityPage.facts.studentsValue"),
    },
    {
      icon: "fas fa-chalkboard-teacher",
      label: t("universityPage.facts.staffLabel"),
      value: t("universityPage.facts.staffValue"),
    },
  ];

  const pillars = [
    {
      icon: "fas fa-chalkboard-teacher",
      title: t("universityPage.pillars.teaching.title"),
      text: t("universityPage.pillars.teaching.text"),
    },
    {
      icon: "fas fa-flask",
      title: t("universityPage.pillars.research.title"),
      text: t("universityPage.pillars.research.text"),
    },
    {
      icon: "fas fa-handshake",
      title: t("universityPage.pillars.community.title"),
      text: t("universityPage.pillars.community.text"),
    },
  ];

  const missionCore = [
    t("unimisija.list1"),
    t("unimisija.list2"),
    t("unimisija.list3"),
  ];

  const missionImplications = [
    t("unimisija.list4"),
    t("unimisija.list5"),
    t("unimisija.list6"),
    t("unimisija.list7"),
    t("unimisija.list8"),
  ];

  const roadmap = [
    {
      year: t("universityPage.roadmap.y2017.year"),
      title: t("universityPage.roadmap.y2017.title"),
      text: t("universityPage.roadmap.y2017.text"),
    },
    {
      year: t("universityPage.roadmap.y2020.year"),
      title: t("universityPage.roadmap.y2020.title"),
      text: t("universityPage.roadmap.y2020.text"),
    },
    {
      year: t("universityPage.roadmap.y2030.year"),
      title: t("universityPage.roadmap.y2030.title"),
      text: t("universityPage.roadmap.y2030.text"),
    },
  ];

  return (
    <>
      <Navbar />
      <Bredcom title={breadcrumbTitle} subtitle={breadcrumbSubtitle} />

      <main className="university-page">
        <div className="container mt-4 pt-40">
          <div className="row">
            {/* MAIN */}
            <div className="col-lg-8">
              {/* HERO */}
              <section className="ua-hero" aria-labelledby="ua-title">
                <div className="ua-hero__content">
                  <div className="ua-eyebrow">
                    <span className="ua-pill">
                      <i className="fas fa-university" aria-hidden="true" />
                      {t("universityPage.eyebrow")}
                    </span>
                  </div>

                  <h1 id="ua-title" className="ua-title">
                    {t("universityPage.heroTitle")}
                  </h1>
                  <p className="ua-subtitle">
                    {t("universityPage.heroSubtitle")}
                  </p>

                  <nav
                    className="ua-hero__nav"
                    aria-label={t("universityPage.inpageNavAria")}
                  >
                    <a className="ua-chip" href="#ua-about">
                      {t("universityPage.nav.about")}
                    </a>
                    <a className="ua-chip" href="#ua-pillars">
                      {t("universityPage.nav.pillars")}
                    </a>
                    <a className="ua-chip" href="#ua-mission">
                      {t("universityPage.nav.mission")}
                    </a>
                    <a className="ua-chip" href="#ua-vision">
                      {t("universityPage.nav.vision")}
                    </a>
                    <a className="ua-chip" href="#ua-goals">
                      {t("universityPage.nav.goals")}
                    </a>
                  </nav>

                  <div className="ua-facts" role="list">
                    {facts.map((f) => (
                      <div className="ua-fact" role="listitem" key={f.label}>
                        <div className="ua-fact__icon" aria-hidden="true">
                          <i className={f.icon} />
                        </div>
                        <div className="ua-fact__meta">
                          <div className="ua-fact__label">{f.label}</div>
                          <div className="ua-fact__value">{f.value}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="ua-hero__aside">
                  <div
                    className="ua-heroMedia ua-heroMedia--logo"
                    style={{ backgroundImage: `url(${heroImg})` }}
                    role="img"
                    aria-label={t("universityPage.media.alt")}
                  />
                  <div className="ua-heroMedia__caption">
                    <i className="fas fa-map-marker-alt" aria-hidden="true" />
                    {t("universityPage.media.caption")}
                  </div>

                  <div className="ua-heroActions">
                    <a
                      className="btn ua-btn"
                      href="https://www.univerzitetadriatik.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("universityPage.cta.website")}
                      <i className="fas fa-arrow-right" aria-hidden="true" />
                    </a>
                  </div>
                </div>
              </section>

              {/* ABOUT */}
              <section id="ua-about" className="ua-section ua-section--story">
                <h2 className="ua-section__title">
                  {t("universityPage.sections.aboutTitle")}
                </h2>
                <p className="ua-copy">{t("univerzitet.p1")}</p>
                <p className="ua-copy">{t("univerzitet.p2")}</p>
              </section>

              {/* PILLARS */}
              <section id="ua-pillars" className="ua-section">
                <h2 className="ua-section__title">
                  {t("universityPage.sections.pillarsTitle")}
                </h2>

                <div className="ua-grid ua-grid--3">
                  {pillars.map((p) => (
                    <article className="ua-card" key={p.title}>
                      <div className="ua-card__icon" aria-hidden="true">
                        <i className={p.icon} />
                      </div>
                      <h3 className="ua-card__title">{p.title}</h3>
                      <p className="ua-card__text">{p.text}</p>
                    </article>
                  ))}
                </div>
              </section>

              {/* MISSION */}
              <section id="ua-mission" className="ua-section">
                <h2 className="ua-section__title">{t("univerzitet.misija")}</h2>

                <p className="ua-copy">{t("unimisija.p1")}</p>
                <ul className="ua-list ua-list--core">
                  {missionCore.map((item) => (
                    <li key={item}>
                      <i className="fas fa-check" aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>

                <p className="ua-copy">{t("unimisija.p2")}</p>
                <ul className="ua-list">
                  {missionImplications.map((item) => (
                    <li key={item}>
                      <i className="fas fa-angle-right" aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </section>

              {/* VISION */}
              <section id="ua-vision" className="ua-section">
                <h2 className="ua-section__title">{t("univerzitet.vizija")}</h2>
                <p className="ua-copy">{t("univizija.p1")}</p>
                <p className="ua-copy">{t("univizija.p2")}</p>
                <p className="ua-copy">{t("univizija.p3")}</p>
              </section>

              {/* GOALS */}
              <section id="ua-goals" className="ua-section">
                <h2 className="ua-section__title">
                  {t("universityPage.sections.roadmapTitle")}
                </h2>

                <div className="ua-grid ua-grid--3 ua-roadmap">
                  {roadmap.map((m) => (
                    <article className="ua-milestone" key={m.year}>
                      <div className="ua-milestone__year">{m.year}</div>
                      <div className="ua-milestone__title">{m.title}</div>
                      <p className="ua-milestone__text">{m.text}</p>
                    </article>
                  ))}
                </div>

                <div className="ua-callout">
                  <div className="ua-callout__title">
                    {t("universityPage.sections.practiceTitle")}
                  </div>
                  <p className="ua-callout__text">
                    {t("universityPage.sections.practiceText")}
                  </p>
                </div>
              </section>
            </div>

            {/* SIDEBAR */}
            <div className="col-lg-4 pt-10">
              <aside className="sidebar-widget ua-sidebar">
                {/* Extra top widget (modern) */}
                <section className="widget ua-widgetCard">
                  <h2 className="widget-title">
                    {t("universityPage.aside.title")}
                  </h2>
                  <div className="ua-widgetBody">
                    <p className="ua-asideText">
                      {t("universityPage.aside.text")}
                    </p>
                    <a
                      className="ua-asideLink"
                      href="https://www.univerzitetadriatik.com/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("universityPage.aside.linkLabel")}
                      <i
                        className="fas fa-external-link-alt"
                        aria-hidden="true"
                      />
                    </a>
                  </div>
                </section>

                {/* KEEP: existing sidebar widgets */}
                <section
                  id="custom_html-5"
                  className="widget_text widget widget_custom_html"
                >
                  <h2 className="widget-title">{t("sidebar.follow")}</h2>
                  <div className="textwidget custom-html-widget">
                    <div className="widget-social">
                      <a
                        href="https://www.facebook.com/fpebar.me"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Facebook"
                      >
                        <i className="fab fa-facebook-f" />
                      </a>
                      <a
                        href="https://www.instagram.com/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Instagram"
                      >
                        <i className="fab fa-instagram" />
                      </a>
                      <a
                        href="https://www.youtube.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="YouTube"
                      >
                        <i className="fab fa-youtube" />
                      </a>
                      <a
                        href="https://www.tiktok.com/@fpepbar"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on Tiktok"
                        title="Tiktok"
                      >
                        <i className="fab fa-tiktok" />
                      </a>
                      <a
                        href="https://www.linkedin.com/school/fpepbar/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow us on LinkedIn"
                        title="LinkedIn"
                      >
                        <i className="fab fa-linkedin-in" />
                      </a>
                    </div>
                  </div>
                </section>

                <section id="categories-1" className="widget widget_categories">
                  <h2 className="widget-title">{t("sidebar.useful")}</h2>
                  <ul>
                    <li className="cat-item cat-item-16">
                      <Link to="/o-fpep">{t("about.fpep")}</Link>
                    </li>
                    <li className="cat-item cat-item-23">
                      <Link to="/akreditacija-fpep">
                        {t("admission.Akreditacija")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-18">
                      <Link to="/upis">{t("upis.title")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/cijene-studija">
                        {t("admission.Skolarina")}
                      </Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/erasmus">{t("saradnja.erasmus")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/projekti">{t("saradnja.projekti")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/dom-studenata">{t("studenti.dom")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/galerija">{t("navbar.Gallery")}</Link>
                    </li>
                    <li className="cat-item cat-item-22">
                      <Link to="/novosti">{t("navbar.News")}</Link>
                    </li>
                  </ul>
                </section>

                <section
                  id="recent-posts-4"
                  className="widget widget_recent_entries"
                >
                  <h2 className="widget-title">{t("sidebar.study")}</h2>
                  <ul>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.osnovne")}</strong> <br />
                      </span>
                      <Link to="/racunovodstvo-finansije-i-bankarstvo">
                        {t("osnovne.rfb")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment">
                        {t("osnovne.menadzment")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-osnovne">
                        {t("osnovne.pravo")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.master")}</strong> <br />
                      </span>
                      <Link to="/poslovna-ekonomija">
                        {t("master.poslovnaEkonomija")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/ekonomija-javnog-sektora">
                        {t("master.ekonomijaJavnogSektora")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/pravo-master">
                        {t("master.pravo")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <span className="post-date">
                        <strong>{t("programs.specijalisticke")}</strong> <br />
                      </span>
                      <Link to="/menadzment-javnog-sektora-specijalisticke">
                        {t("specijalisticke.mjs")}
                        <br />
                      </Link>
                    </li>
                    <li>
                      <Link to="/menadzment-profitnog-sektora-specijalisticke">
                        {t("specijalisticke.mps")}
                        <br />
                      </Link>
                    </li>
                  </ul>
                </section>
              </aside>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}

export default OUniverzitetu;
